import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { navigate } from 'gatsby';
import Image_Free_3 from '../assets/images/Image_Free_3.png';

const CTASection = () => {
  const handleWhitePaperClick = () => {
    navigate('/white-papers');
  };

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        width: '100vw',
        height: '696px',
        background: '#010405',
        overflow: 'hidden',
        marginLeft: 'calc(-50vw + 50%)',
        marginRight: 'calc(-50vw + 50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        component="img"
        src={Image_Free_3}
        sx={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          objectFit: 'cover',
          zIndex: 2,
        }}
      />
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 3,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '843px',
            padding: '50px',
            background: 'rgba(255, 255, 255, 0.15)',
            borderRadius: '10px',
            backdropFilter: 'blur(12.50px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '35px',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: '#FFF',
              textAlign: 'center',
              fontSize: '48px',
              fontWeight: 700,
              lineHeight: '56px',
            }}
          >
            Check our White Papers
          </Typography>
          <Typography
            sx={{
              color: '#FFF',
              textAlign: 'center',
              fontSize: '24px',
              fontWeight: 400,
              lineHeight: '32px',
              maxWidth: '743px',
              fontFamily: 'Nunito Sans',
            }}
          >
            Our industry experts have some interesting white papers for you to read. Feel free to download them to start up a conversation with us.
          </Typography>
          <Button
            variant="contained"
            onClick={handleWhitePaperClick}
            sx={{
              padding: '15px 25px',
              background: '#FFF',
              color: '#000',
              borderRadius: '55px',
              fontSize: '24px',
              fontWeight: 600,
              textTransform: 'none',
              fontFamily: 'Nunito Sans',
              '&:hover': {
                background: 'rgba(255, 255, 255, 0.9)',
              },
            }}
          >
            Find out more!
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default CTASection; 